<template>
    <div class="news-slider-wrapper">
        <Loading v-if="loading" class="mt-5 p-5"/>
        <b-carousel v-else
                    indicators
                    :fade="true"
                    :interval="5000"
        >
            <b-carousel-slide v-for="slide in slides"
                              :key="'slider' + slide.idSlider"
                              :img-src="getImage(slide.image)"
            >
                <h2>{{slide.headline}}</h2>
                <p>{{slide.description}}</p>
                <div class="pt-2 text-right">
                    <a :href="slide.url" target="_blank" class="btn btn-sm mr-1 btn-link">Viac informácií</a>
                    <button type="button" class="btn btn-sm btn-primary" @click="showModal(slide.request)">Mám záujem</button>
                </div>
            </b-carousel-slide>
        </b-carousel>
      <Request ref="request" type="trade" :requestInfo="tradeRequest"/>
    </div>
</template>

<script>
    import {BCarousel} from 'bootstrap-vue';
    import Loading from "./Loading";
    import { getImageFromBytea } from "../store/helpers";
    import Request from "./Request";

    export default {
        name: "News",
        components: {
            BCarousel, Loading, Request
        },
        data() {
            return {
                tradeRequest: {
                    isSale: false,
                    code: '',
                    message: '',
                    disabled: true
                }
            }
        },
        mounted() {
            this.$store.dispatch('content/slider');
        },
        methods: {
            getImage(input) {
                return getImageFromBytea(input);
            },
            showModal(message) {
                this.tradeRequest.message = message;
                this.$refs.request.show();
            }
        },
        computed: {
            slides() {
                return this.$store.state.content.slides
            },
            loading() {
                return this.$store.state.content.loading;
            }
        },
    }
</script>

<style lang="scss">
    @import "@/assets/styles/variables.scss";

    .news-slider-wrapper {
        .carousel-item {
            @include media-breakpoint-up(xl) {
                height: 300px;
            }

            img {
                max-width: 50% !important;
                max-height: 85% !important;

                @include media-breakpoint-down(lg) {
                    max-width: 100% ! important;
                }
            }

            .carousel-caption {
                position: absolute;
                top: auto;
                bottom: 0;
                right: 0;
                left: auto;
                width: 55%;
                background: $secondary-bg;
                text-align: left;
                padding: 30px;

                @include media-breakpoint-down(lg) {
                    position: relative;
                    width: 100%;
                }

                h2 {
                    font-size: 20px;
                    line-height: 150%;
                }

                p {
                    font-size: 13px;
                    line-height: 115%;
                    color: $secondary-text;
                }

                .btn-link {
                    color: #fff;
                    text-decoration: underline;
                    font-size: 13px;
                }
            }
        }

        .carousel-indicators {
            right: 60%;
            justify-content: flex-end;
            align-items: flex-end;
            margin: 0;

            @include media-breakpoint-down(lg) {
                position: relative;
                justify-content: center;
                bottom: -20px;
            }

            li {
                width: 9px;
                height: 9px;
                margin: 0 0 0 9px;
                padding: 0;
                border-width: 0;
                background: #cbcbcb;
                opacity: 1;
                outline: none;
                box-shadow: none;

                &.active {
                    background: $blue;
                }
            }
        }
    }
</style>